<template>
  <div class="row mt-4" v-if="productos.length">
    <div class="col-12">
      <div class="card ficha-listado mb-4">
        <div class="px-4 pb-4 card-body">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h6 class="mb-0 panel-section-title">Productos</h6>
              <p class="text-xs opacity-7 mb-0">Mostrando: <b>{{ productosFiltrados.length }}</b> de {{ productos.length }}</p>
            </div>
            <label class="d-flex align-items-center gap-2 mb-0" style="cursor:pointer;font-size:0.85rem;">
              <input type="checkbox" v-model="soloConVentas" style="accent-color:var(--q-gold);" />
              Solo con ventas
            </label>
          </div>

          <div class="table-responsive">
            <table class="table table-flush table-listado table-empirulada">
              <thead class="thead-light">
                <tr>
                  <th :class="['th-sort', thSortClass('producto')]" @click="sortBy('producto')">Producto</th>
                  <th :class="['th-sort', 'text-center', thSortClass('ventas')]" @click="sortBy('ventas')">Ventas</th>
                  <th :class="['th-sort', 'text-end', thSortClass('precio')]" @click="sortBy('precio')">Precio</th>
                  <th :class="['th-sort', 'text-end', thSortClass('ticket')]" @click="sortBy('ticket')">Precio real</th>
                  <th :class="['th-sort', 'text-end', thSortClass('ingresos')]" @click="sortBy('ingresos')">Ingresos</th>
                  <th :class="['th-sort', thSortClass('ultima_venta')]" @click="sortBy('ultima_venta')">Última venta</th>
                  <th class="text-center sin-orden">Compradores</th>
                  <th :class="['th-sort', 'text-center', thSortClass('activo')]" @click="sortBy('activo')">Activo</th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr v-for="p in prodPageRows" :key="p.producto_id">
                  <td>
                    <div class="d-flex align-items-center gap-2 flex-wrap">
                      <b>{{ p.producto }}</b>
                      <span v-if="p.borrado" class="badge bg-secondary">Borrado</span>
                    </div>
                  </td>
                  <td class="text-center">{{ p.ventas ?? 0 }}</td>
                  <td class="text-end td-precio">{{ formatMoney(p.precio ?? 0, p.moneda) }}</td>
                  <td class="text-end td-precio-real">
                    <span :class="precioRealClass(p)">{{ formatMoney(p.ticket_medio ?? 0, p.moneda) }}</span>
                  </td>
                  <td class="text-end">{{ formatMoney(p.ingresos ?? 0, p.moneda) }}</td>
                  <td>{{ fmtFechaDMY(p.ultima_venta) }}</td>
                  <td class="text-center">
                    <button
                      class="btn btn-ver btn-sm"
                      @click="abrirCompradores(p)"
                      :disabled="loadingCompradores"
                      title="Ver compradores"
                    >Ver</button>
                  </td>
                  <td class="text-center">
                    <span class="badge-estado" :class="p.activo ? 'badge-ok' : 'badge-muted'">
                      {{ p.activo ? "Sí" : "No" }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Paginación productos -->
          <div v-if="prodTotalPages > 1" class="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-3">
            <p class="text-xs opacity-7 mb-0">{{ prodFrom }}-{{ prodTo }} de {{ productos.length }}</p>
            <div class="btn-group">
              <button class="btn btn-sm btn-pagi mb-0" :disabled="prodPage <= 1" @click="prodPage = 1">«</button>
              <button class="btn btn-sm btn-pagi mb-0" :disabled="prodPage <= 1" @click="prodPage--">‹</button>
              <button class="btn btn-sm btn-pagi mb-0" disabled>{{ prodPage }} / {{ prodTotalPages }}</button>
              <button class="btn btn-sm btn-pagi mb-0" :disabled="prodPage >= prodTotalPages" @click="prodPage++">›</button>
              <button class="btn btn-sm btn-pagi mb-0" :disabled="prodPage >= prodTotalPages" @click="prodPage = prodTotalPages">»</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal compradores -->
  <div v-if="modalOpen" class="q-modal-overlay" @click.self="cerrar">
    <div class="q-modal">
      <div class="q-modal-head">
        <div>
          <h6 class="mb-0 panel-section-title">Compradores del producto</h6>
          <p class="text-sm opacity-7 mb-0"><b>{{ modalProducto?.producto || "-" }}</b></p>
        </div>
        <button class="q-modal-close" @click="cerrar" aria-label="Cerrar">✕</button>
      </div>

      <div class="q-modal-body">
        <div v-if="loadingCompradores" class="alert alert-secondary text-sm">Cargando compradores...</div>
        <div v-else-if="errorCompradores" class="alert alert-danger text-sm">{{ errorCompradores }}</div>
        <div v-else-if="compradores.length === 0" class="alert alert-secondary text-sm">
          Este producto no tiene compras completadas.
        </div>
        <div v-else class="table-responsive">
          <table class="table table-flush table-listado table-empirulada">
            <thead class="thead-light">
              <tr>
                <th>Email</th>
                <th>Fecha y hora</th>
                <th class="text-center">País</th>
                <th>Nick Telegram</th>
                <th>Referencia</th>
              </tr>
            </thead>
            <tbody class="text-sm">
              <tr v-for="(c, idx) in compradoresPageRows" :key="c.pedido_id || idx">
                <td><b>{{ c.email || "-" }}</b></td>
                <td>{{ fmtFechaHora(c.fecha) }}</td>
                <td class="text-center td-pais">
                  <span v-if="c.pais" :class="'fi fi-' + c.pais.toLowerCase() + ' fis flag-icon'" :title="c.pais"></span>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <a v-if="c.telegram_username"
                     :href="`https://t.me/${c.telegram_username}`"
                     target="_blank"
                     rel="noopener"
                     class="tg-nick"
                  >@{{ c.telegram_username }}</a>
                  <span v-else-if="c.telegram_id" class="text-muted text-xs">ID {{ c.telegram_id }}</span>
                  <span v-else class="text-muted text-xs">—</span>
                </td>
                <td>{{ c.referencia || "-" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="q-modal-foot q-modal-foot-split">
        <div v-if="!loadingCompradores && compradoresTotalPages > 1" class="q-pager">
          <div class="q-pager-info text-xs opacity-7">
            Mostrando <b>{{ compradoresFrom }}</b>-<b>{{ compradoresTo }}</b> de <b>{{ compradoresTotal }}</b>
          </div>
          <div class="btn-group">
            <button class="btn btn-sm btn-pagi" :disabled="page === 1" @click="page = 1">«</button>
            <button class="btn btn-sm btn-pagi" :disabled="page === 1" @click="page--">‹</button>
            <button class="btn btn-sm btn-pagi" disabled>{{ page }} / {{ compradoresTotalPages }}</button>
            <button class="btn btn-sm btn-pagi" :disabled="page === compradoresTotalPages" @click="page++">›</button>
            <button class="btn btn-sm btn-pagi" :disabled="page === compradoresTotalPages" @click="page = compradoresTotalPages">»</button>
          </div>
        </div>
        <button class="btn-cerrar" @click="cerrar">Cerrar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelTipsterProductos",
  props: {
    productos: { type: Array, default: () => [] },
  },
  data() {
    return {
      soloConVentas: true,
      sortCol: 'ventas',
      sortDir: 'desc',
      modalOpen: false,
      modalProducto: null,
      compradores: [],
      loadingCompradores: false,
      errorCompradores: "",
      page: 1,
      perPage: 10,
      prodPage: 1,
      prodPerPage: 8,
    };
  },
  computed: {
    productosFiltrados() {
      return this.soloConVentas ? this.productos.filter(p => (p.ventas ?? 0) > 0) : this.productos;
    },
    productosSorted() {
      const arr = [...this.productosFiltrados];
      if (!this.sortCol) return arr;
      const dir = this.sortDir === 'asc' ? 1 : -1;
      return arr.sort((a, b) => {
        let va, vb;
        switch (this.sortCol) {
          case 'producto':     va = (a.producto || '').toLowerCase(); vb = (b.producto || '').toLowerCase(); break;
          case 'ventas':       va = a.ventas ?? 0;       vb = b.ventas ?? 0;       break;
          case 'precio':       va = a.precio ?? 0;       vb = b.precio ?? 0;       break;
          case 'ingresos':     va = a.ingresos ?? 0;     vb = b.ingresos ?? 0;     break;
          case 'ticket':       va = a.ticket_medio ?? 0; vb = b.ticket_medio ?? 0; break;
          case 'ultima_venta': va = a.ultima_venta || ''; vb = b.ultima_venta || ''; break;
          case 'activo':       va = a.activo ? 1 : 0;   vb = b.activo ? 1 : 0;   break;
          default: return 0;
        }
        if (va < vb) return -dir;
        if (va > vb) return dir;
        return 0;
      });
    },
    prodTotalPages() { return Math.max(1, Math.ceil(this.productosSorted.length / this.prodPerPage)); },
    prodPageRows() {
      const start = (this.prodPage - 1) * this.prodPerPage;
      return this.productosSorted.slice(start, start + this.prodPerPage);
    },
    prodFrom() { return this.productosSorted.length === 0 ? 0 : (this.prodPage - 1) * this.prodPerPage + 1; },
    prodTo() { return Math.min(this.prodPage * this.prodPerPage, this.productosSorted.length); },
    compradoresTotal() { return this.compradores.length; },
    compradoresTotalPages() { return Math.max(1, Math.ceil(this.compradoresTotal / this.perPage)); },
    compradoresPageRows() {
      const start = (this.page - 1) * this.perPage;
      return this.compradores.slice(start, start + this.perPage);
    },
    compradoresFrom() { return this.compradoresTotal === 0 ? 0 : (this.page - 1) * this.perPage + 1; },
    compradoresTo() { return Math.min(this.page * this.perPage, this.compradoresTotal); },
  },
  watch: {
    productos() { this.prodPage = 1; },
    soloConVentas() { this.prodPage = 1; },
    sortCol() { this.prodPage = 1; },
  },
  methods: {
    sortBy(col) {
      if (this.sortCol === col) {
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortCol = col;
        this.sortDir = col === 'producto' ? 'asc' : 'desc';
      }
    },
    thSortClass(col) {
      if (this.sortCol !== col) return '';
      return this.sortDir; // 'asc' o 'desc' → el CSS global aplica la imagen correspondiente
    },
    async abrirCompradores(p) {
      this.page = 1;
      this.modalOpen = true;
      this.modalProducto = p;
      this.loadingCompradores = true;
      this.errorCompradores = "";
      this.compradores = [];
      try {
        const resp = await this.$store.dispatch("auth/tipsterProductoCompradores", { producto_id: p.producto_id });
        const data = resp?.data ?? resp;
        if (data?.res && data.res !== "OK") throw new Error(data?.mensaje || "Respuesta no OK");
        this.compradores = Array.isArray(data?.compradores) ? data.compradores : [];
      } catch (e) {
        this.errorCompradores = e?.message || "No se pudieron cargar compradores";
      } finally {
        this.loadingCompradores = false;
      }
    },
    cerrar() {
      this.modalOpen = false;
      this.modalProducto = null;
      this.compradores = [];
      this.errorCompradores = "";
    },
    precioRealClass(p) {
      const precio = parseFloat(p.precio ?? 0);
      const real   = parseFloat(p.ticket_medio ?? 0);
      if (p.ventas === 0 || precio === 0) return '';
      if (real < precio - 0.01) return 'precio-real--desc';
      return 'precio-real--igual';
    },
    formatMoney(n, moneda) {
      const cur = (moneda || 'EUR').toUpperCase();
      const locale = cur === 'USD' ? 'en-US' : 'es-ES';
      return Number(n || 0).toLocaleString(locale, { style: "currency", currency: cur });
    },
    fmtFechaDMY(fechaStr) {
      if (!fechaStr) return "";
      const onlyDate = String(fechaStr).split(" ")[0].split("T")[0];
      const [y, m, d] = onlyDate.split("-");
      return (y && m && d) ? `${d}-${m}-${y}` : onlyDate;
    },
    fmtFechaHora(fechaStr) {
      if (!fechaStr) return "-";
      const s = String(fechaStr).replace("T", " ");
      const [datePart, timePart] = s.split(" ");
      if (!datePart) return s;
      const [y, m, d] = datePart.split("-");
      const hhmm = (timePart || "").slice(0, 5);
      return `${d}-${m}-${y} ${hhmm}`;
    },
  },
};
</script>

<style scoped>
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover { color: var(--q-gold); }

.btn-ver {
  background: linear-gradient(90deg, var(--q-gold), var(--q-gold-hover));
  border: 0;
  color: var(--q-gold-on);
  border-radius: 10px;
  padding: 6px 12px;
  font-weight: 700;
}
.btn-ver:disabled { opacity: .6; }

.badge-estado {
  display: inline-block; padding: 3px 9px; border-radius: 20px;
  font-size: 11px; font-weight: 700; white-space: nowrap;
}
.badge-ok   { background: var(--q-green-soft); color: var(--q-green); border: 1px solid var(--q-green); }
.badge-muted{ background: var(--q-hover);      color: var(--q-muted);  border: 1px solid var(--q-border-md); }

.btn-pagi {
  background: var(--q-card-alt); border: 1px solid var(--q-border-md);
  color: var(--q-muted); padding: 4px 10px; font-size: 0.8rem;
  transition: .15s;
}
.btn-pagi:hover:not(:disabled) { background: var(--q-hover); color: var(--q-gold); border-color: var(--q-gold); }
.btn-pagi:disabled { opacity: .4; cursor: not-allowed; }

.btn-cerrar {
  background: var(--q-card-alt); border: 1px solid var(--q-border-md);
  color: var(--q-muted); padding: 7px 20px; border-radius: 8px;
  font-size: 0.85rem; font-weight: 600; cursor: pointer; transition: .15s;
}
.btn-cerrar:hover { background: var(--q-hover); color: var(--q-text); }

.table-empirulada { border-collapse: separate !important; border-spacing: 0 10px; }
.table-empirulada thead th { border: 0 !important; background: var(--q-hover); color: var(--q-text); font-weight: 700; padding: 12px 14px; }
.table-empirulada tbody tr { background: var(--q-card); box-shadow: 0 6px 18px rgba(0,0,0,.06); }
.table-empirulada tbody td { border: 0 !important; padding: 12px 14px; vertical-align: middle; }
.table-empirulada > :not(caption) > * > * { border-bottom-width: 0 !important; }
.table-empirulada tbody tr:hover { transform: translateY(-1px); transition: .15s ease; }
.table-empirulada tbody tr td:first-child { border-top-left-radius: 12px; border-bottom-left-radius: 12px; }
.table-empirulada tbody tr td:last-child { border-top-right-radius: 12px; border-bottom-right-radius: 12px; }
.table-empirulada tbody tr { overflow: hidden; }
.table-empirulada thead, .table-empirulada thead tr, .table-empirulada thead th { border-radius: 0 !important; }
.table-empirulada thead th:first-child, .table-empirulada thead th:last-child {
  border-top-left-radius: 0 !important; border-top-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important; border-bottom-right-radius: 0 !important;
}
.table-empirulada thead tr { box-shadow: none !important; background: transparent !important; }

.q-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(10, 15, 25, 0.55);
  backdrop-filter: blur(7px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 9999;
  padding: 14px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.q-modal {
  width: 100%;
  max-width: 860px;
  background: linear-gradient(180deg, var(--q-card) 0%, var(--q-card-alt) 100%);
  border-radius: 18px;
  border: 1px solid var(--q-border);
  box-shadow: 0 18px 55px rgba(0,0,0,0.28);
  overflow: hidden;
  margin: 14px auto;
  max-height: calc(100vh - 28px);
  display: flex;
  flex-direction: column;
}
.q-modal-head {
  padding: 16px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--q-border);
  flex-shrink: 0;
}
.q-modal-close { border: 0; background: transparent; font-size: 20px; line-height: 1; opacity: .7; }
.q-modal-close:hover { opacity: 1; }
.q-modal-body { padding: 14px 18px; overflow-y: auto; -webkit-overflow-scrolling: touch; flex: 1 1 auto; }
.q-modal-foot {
  padding: 12px 18px 16px 18px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid var(--q-border);
  flex-shrink: 0;
}
.q-modal-foot-split { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; }
.q-pager { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }

.tg-nick {
  color: #26c6da;
  font-weight: 600;
  font-size: 12px;
  text-decoration: none;
  white-space: nowrap;
}
.tg-nick:hover { text-decoration: underline; opacity: .85; }

@media (max-width: 576px) {
  .q-modal-head { padding: 12px 14px; }
  .q-modal-body { padding: 10px 14px; }
  .q-modal-foot { padding: 10px 14px 12px 14px; }
}

.td-precio      { white-space: nowrap; opacity: .75; font-size: 12px; }
.td-precio-real { white-space: nowrap; }
.precio-real--igual { color: var(--q-text); }
.precio-real--desc  { color: #ffc107; font-weight: 600; }
</style>
